/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : customerSlice.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Redux Slice for Customer state
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Dec 22, 2021
 *
 * @Version      : Version 1.0
 *
 * By            : H422337
 * On            : Dec 22, 2021
 * Description   : Create a customer store
 *
 *
 ******************************************************************************/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomerState, ICustomer } from "models/customer";
import { AppThunk, RootState } from "stores/GlobalStore";
import { apiCallBegan, apiVersion, apmURLs } from "api";

export const initialState: ICustomerState = {
  customerList: null,
  selectedCustomer: null,
  CustomerLoader: false,
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    startCustomerLoader(customerState: ICustomerState) {
      customerState.CustomerLoader = true;
    },
    setCustomerList(
      customerState: ICustomerState,
      action: PayloadAction<ICustomer[]>
    ) {
      customerState.customerList = action.payload;
      customerState.CustomerLoader = false;
    },
    resetCustomerList(customerState: ICustomerState) {
      customerState.customerList = [];
      customerState.CustomerLoader = false;
    },
    setSelectedCustomer(
      customerState: ICustomerState,
      action: PayloadAction<ICustomer | null>
    ) {
      customerState.selectedCustomer = action.payload;
    },
  },
});

export const {
  startCustomerLoader,
  setCustomerList,
  resetCustomerList,
  setSelectedCustomer,
} = customerSlice.actions;

export const customerReducer = customerSlice.reducer;

export const fetchCustomers = (): AppThunk => async (dispatch) => {
  const url = apiVersion.v1 + apmURLs.CUSTOMER_LIST_URL;

  dispatch(
    apiCallBegan({
      url,
      onStart: startCustomerLoader.type,
      onSuccess: setCustomerList.type,
      onError: resetCustomerList.type,
      showGlobalError: true,
    })
  );
};

export const selectCustomerList = (state: RootState): ICustomer[] | null =>
  state.customer.customerList;
export const selectCustomer = (state: RootState): ICustomer | null =>
  state.customer.selectedCustomer;
export const selectLoader = (state: RootState): boolean =>
  state.customer.CustomerLoader;
